import { useCallback, useEffect, useState } from 'react';

const STATUS_BAR_ALLOWANCE = 96; // desktop status bar plus a little breathing room

/**
 * Max height for a FloatingPanel so its bottom stays above the status bar.
 * Attach the returned ref to any element inside the panel; the panel's
 * position is measured from the area it is placed in, not the window.
 */
export const usePanelMaxHeight = (fallback = 480) => {
  const [node, setNode] = useState(null);
  const [maxHeight, setMaxHeight] = useState(fallback);

  const measure = useCallback(() => {
    const panel = node?.closest('[data-panel="true"]');
    if (!panel) return;
    const top = panel.getBoundingClientRect().top;
    setMaxHeight(Math.max(240, Math.floor(window.innerHeight - top - STATUS_BAR_ALLOWANCE)));
  }, [node]);

  useEffect(() => {
    measure();
    // Re-fit after the window resizes or the panel is dragged somewhere new
    window.addEventListener('resize', measure);
    window.addEventListener('pointerup', measure);
    return () => {
      window.removeEventListener('resize', measure);
      window.removeEventListener('pointerup', measure);
    };
  }, [measure]);

  return [setNode, maxHeight];
};

export default usePanelMaxHeight;
